import React, { useContext } from "react";
import classes from "./ForeignCard.module.css";
import ExtractFromHtml, {
  extractTextFromHTML,
} from "../../../../components/extract-from-html/ExtractFromHtml";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../../App";

const ForeignCard = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  return (
    <div className={classes.outer}>
      <img
        src={data?.images?.find((item) => item?.mainImage == "yes")?.url}
        alt={data?.images?.find((item) => item?.mainImage == "yes")?.imageTag}
      />
      <h1>{data?.title}</h1>
      {/* <div className={`${classes.underLine} bg-secondary-300`}></div> */}
      <p>{extractTextFromHTML(data?.homeDescription)}</p>
      <button
        className="primaryHover"
        onClick={() => {
          const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              setIsBackNavigation(true)
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
          navigate(`/pages/${data?.slug}`)}}
      >
        Know More
      </button>
    </div>
  );
};

export default ForeignCard;
